export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:1337";
export const ROOT_URL = process.env.REACT_APP_ROOT_URL || "";